import { useContext } from "react";
import DataContext from "../../context/DataContext";
import styles from "../components.module.sass";
import { ImageWbd } from "./ImageWbd";
import { SizeScaleSelector } from "./SizeScaleSelector";
import { ProductProps } from "../../interfaces/interfaces";

export const WBDDesign = () => {
  const {
    data: { wbdDesign },
    onUpdateTally,
  } = useContext(DataContext);

  const handleUpdateSize = (
    index: number,
    item: ProductProps,
    value: number,
  ) => {
    onUpdateTally(index, { ...item, size: value }, true);
  };

  return (
    <>
      {wbdDesign.length > 0 && (
        <div className={styles.wbdContainer}>
          <table className={styles.tableWbd}>
            <thead>
              <tr>
                <th>Tool</th>
                <th>Detail</th>
                <th>Size Scale</th>
              </tr>
            </thead>
            <tbody>
              {wbdDesign.map((item, index) => (
                <tr key={index}>
                  <td style={{ width: "40%" }}>
                    <ImageWbd item={item} />
                  </td>
                  <td style={{ width: "30%" }}>
                    <div className={styles.toolDescription}>
                      {item.tool.name || item.tool.description}
                    </div>
                  </td>
                  <td style={{ width: "30%" }}>
                    <SizeScaleSelector
                      value={item.tool.size || 1}
                      onChange={(v) => handleUpdateSize(index, item.tool, v)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};
